import { Info } from "lucide-react";
export default function MediosDePago() {
  return <section data-section-id="264040" id="medios-de-pago" className="bg-muted py-32">
      <div className="container mx-auto px-4 flex flex-col items-center text-center">
        <div className="flex items-center justify-center gap-8 mb-8 opacity-40 grayscale hover:grayscale-0 transition-all duration-300">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/visa_logo.png" alt="Visa" className="h-8 w-auto" width="80" height="32" loading="lazy" decoding="async" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/mastercard_logo.png" alt="Mastercard" className="h-8 w-auto" width="80" height="32" loading="lazy" decoding="async" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/paypal_logo.png" alt="PayPal" className="h-8 w-auto" width="80" height="32" loading="lazy" decoding="async" />
        </div>
        <h4 className="text-2xl font-bold font-default text-foreground mb-4">
          Aceptamos Todos los Medios de Pago
        </h4>
        <p className="text-base font-default text-muted-foreground max-w-[640px] mx-auto leading-relaxed">
          Flexibilidad en tus opciones de pago. Trabajamos con las principales tarjetas de crédito, transferencias bancarias y plataformas digitales para brindarte la mayor comodidad en cada transacción.
        </p>
      </div>
    </section>;
}